import { useUserContext } from "context/UserContext";
import React from "react";
import { useNavigate } from "react-router-dom";

const Logout = () => {
  let { isLoggedIn, setIsLoggedIn, setToken } = useUserContext();
  let navigate = useNavigate();
  if (isLoggedIn) {
    localStorage.setItem("userToken", ``);
    setIsLoggedIn(false);
    setToken(``);
    setTimeout(() => {
      navigate("/home");
      location.reload();
    }, 1500);
  }
  return;
};

export default Logout;
